import { render } from "./qualityInspection.vue?vue&type=template&id=923ecd96&scoped=true"
import script from "./qualityInspection.vue?vue&type=script&lang=js"
export * from "./qualityInspection.vue?vue&type=script&lang=js"

import "./qualityInspection.vue?vue&type=style&index=0&id=923ecd96&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-923ecd96"

export default script